export interface DeviceInfo {
  estimatedRAM: number;
  isLowMemory: boolean;
  isSlowConnection: boolean;
}

export interface SessionOptions {
  executionProviders: string[];
  graphOptimizationLevel: string;
  logSeverityLevel: number;
  logVerbosityLevel?: number;
  enableCpuMemArena: boolean;
  enableMemPattern: boolean;
  executionMode: string;
  interOpNumThreads: number;
  intraOpNumThreads: number;
}

export interface IDeviceStrategy {
  getDeviceInfo(): DeviceInfo;
  getSessionOptions(debug: boolean): SessionOptions;
  shouldUseSequentialLoading(): boolean;
}